import { useState, useEffect } from 'react'

function RSVPUpdates(props) {
    const [rsvpUpdates, setRsvpUpdates] = useState(null)
    const [pageLoading, setPageLoading] = useState(true);
    const [loadingError, setLoadingError] = useState(false);

    useEffect(() => {
        fetchData();
    }, []);

    async function fetchData() {
        try {
            const res = await fetch(
                `https://wedding-website-backend-nu.vercel.app/api/changes`
            );

            if (!res.ok) {
                throw new Error(`HTTP error! status: ${res.status}`);
            }

            const data = await res.json();
            setRsvpUpdates(data.changes);
        } catch (err) {
            console.error(err);
            setLoadingError(true);
        } finally {
            setPageLoading(false);
        }
    }

    async function acknowledgeRSVP(id) {
        try {
            const response = await fetch(
                `https://wedding-website-backend-nu.vercel.app/api/changes`,
                {
                    method: "POST", // changed from PATCH to POST
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ id }),
                }
            );

            const res = await response.json();
            if (res.modifiedCount === 1) {
                setRsvpUpdates(prevUpdates => prevUpdates.filter(update => update._id !== id));
            }
        } catch (err) {
            console.error(err);
        }
    }

    const renderResponse = (bool) => {
        if (bool === true) return "Yes";
        if (bool === false) return "No";
        return bool;
    }

    function renderChange(change) {
        const date = new Date(change.created_at);
        const options = {
            timeZone: "America/New_York",
            year: "numeric",
            month: "long",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
            second: "numeric",
        };
        const estDateStr = date.toLocaleString("en-US", options);

        const renderGuest = (guest) => (
            <li key={guest.name} className="p-2 border-b">
                <div className="subheading text-black">{guest.name.toUpperCase()}</div>
                <div className="text-sm text-customGray mt-1">
                    <div>Attending Welcome Party: {String(renderResponse(guest.attend_welcome_party))}</div>
                    <div>Attending Wedding: {String(renderResponse(guest.attend_wedding))}</div>
                    <div>Wedding Entree: {String(guest.wedding_entree)}</div>
                    <div>Dietary Restrictions: {String(guest.dietary_restrictions)}</div>
                </div>
            </li>
        );

        return (
            <div
                key={change._id}
                className="bg-white shadow-md rounded-lg p-6 mb-6 border border-gray-200"
            >
                <div className="mb-4">
                    <button
                        className="hover:bg-rose hover:text-white bg-blush border border-rose text-customGray rounded py-1 px-2"
                        onClick={() => { acknowledgeRSVP(change._id) }}
                    >
                        Acknowledge
                    </button>
                </div>
                <div className="text-xs text-gray-500 mb-2">{estDateStr}</div>
                <div className="text-xs text-gray-500 mb-2">IP Address: {change.ip_address}</div>
                <ul className="space-y-2">{change.guests.map(renderGuest)}</ul>
                <div className="mb-4"></div>
                <div className="font-medium mb-1">Email: {String(change.email)}</div>
                <div className="font-medium mb-1">Phone: {String(change.phone)}</div>
                <div className="mb-4">
                    <span className="font-semibold">Comments: </span>
                    <span>{change.comments || ""}</span>
                </div>
            </div>
        );
    }

    return (
        <div className="mt-10 p-4 bg-blush min-h-96 rounded-md">
            <div className="subheading text-rose mb-6 text-2xl">Recent RSVPs Updates</div>
            {pageLoading && <p>Loading...</p>}
            {loadingError && <p className="text-red-400">Failed to fetch RSVP updates</p>}
            {!pageLoading && !loadingError && (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 text-sm">
                    {rsvpUpdates.filter(change => !change.reviewed).map(renderChange)}
                </div>
            )}
        </div>
    )
}

export default RSVPUpdates
